<template>
  <b-progress
    :max="100"
    show-value
    class="w-75 progress"
    height="1.3rem"
    :class="{ 'd-flex justify-content-center align-items-center': this.value === 0 }"
  >
    <b-progress-bar :value="value" :variant="progressVariant">
      <span>{{ value.toFixed() }} %</span>
    </b-progress-bar>
    <span v-if="this.value === 0">
      0 %
    </span>
  </b-progress>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  computed: {
    progressVariant () {
      if (this.value === 100) {
        return 'success'
      }
      return 'primary'
    }
  }
}
</script>

<style lang="sass" scoped>
.progress
  min-width: 100px
</style>
